export default `
query getCustomerDatas{
    customer {
     custom_attributes {
        attribute_code
        value
     }
     orders {
        items {
          items {
            product_sku
          }
        }
      }
    }
  }
`